import React, { useState } from 'react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const [selected, setSelected] = useState<'premium' | 'basic'>('premium');
  const checkoutUrl = selected === 'basic' ? 'https://checkout.ars.descargatop.com/cart/46942758600962:1' : 'https://checkout.ars.descargatop.com/cart/47452901703938:1';
  return <section id="pricing" className="py-12 md:py-16 px-4 bg-[#111111] scroll-mt-10" data-id="element-107">
      <div className="max-w-3xl mx-auto" data-id="element-108">
        <div data-id="element-109">
          <div className="text-center mb-10" data-id="element-110">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-3 uppercase tracking-tight" data-id="element-111">
              🛒 ELEGÍ TU PLAN
            </h2>
            <p className="text-base md:text-lg text-gray-400 font-medium" data-id="element-112">
              Descarga inmediata. Acceso de por vida.
            </p>
          </div>

          <div className="space-y-4 mb-8" data-id="element-113">
            {/* Basic Plan Row */}
            <button onClick={() => setSelected('basic')} className={`w-full rounded-xl p-4 flex items-center gap-3 md:gap-4 transition-all duration-300 cursor-pointer text-left ${selected === 'basic' ? 'bg-[#1a1a1a] border-2 border-gray-500' : 'bg-[#1a1a1a] border-2 border-[#2a2a2a] opacity-70 hover:opacity-90'}`} data-id="element-114">
              {/* Radio */}
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'basic' ? 'border-white' : 'border-gray-600'}`} data-id="element-115">
                {selected === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-116" />}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0" data-id="element-117">
                <div className="flex items-center gap-2 mb-1" data-id="element-118">
                  <span className="text-lg" data-id="element-119">📘</span>
                  <h3 className="text-base md:text-lg font-black text-white uppercase tracking-wide" data-id="element-120">
                    PACK BÁSICO
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-121">
                  4 libros + 400 citas + bonos
                </p>
                <div className="flex flex-col gap-0.5 mt-1.5" data-id="element-122">
                  <p className="text-[11px] md:text-xs text-gray-400" data-id="element-123">
                    📘 100 Citas Mamá e Hija
                  </p>
                  <p className="text-[11px] md:text-xs text-gray-400" data-id="element-124">
                    📗 100 Citas Mamá e Hijo
                  </p>
                  <p className="text-[11px] md:text-xs text-gray-400" data-id="element-125">
                    📙 100 Citas Papá e Hija
                  </p>
                  <p className="text-[11px] md:text-xs text-gray-400" data-id="element-126">
                    📕 100 Citas Papá e Hijo
                  </p>
                </div>
              </div>

              {/* Price */}
              <div className="text-right flex-shrink-0" data-id="element-127">
                <p className="text-xs md:text-sm text-gray-500 line-through font-medium" data-id="element-128">
                  $39.990
                </p>
                <p className="text-2xl md:text-3xl font-black text-white" data-id="element-129">
                  $19.990
                </p>
              </div>
            </button>

            {/* Premium Plan Row */}
            <button onClick={() => setSelected('premium')} className={`w-full rounded-xl p-4 flex items-center gap-3 md:gap-4 transition-all duration-300 cursor-pointer text-left relative ${selected === 'premium' ? 'bg-[#1a1a00] border-2 border-yellow-400 shadow-md' : 'bg-[#1a1a1a] border-2 border-[#2a2a2a] opacity-70 hover:opacity-90'}`} data-id="element-130">
              {/* Radio */}
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'premium' ? 'border-yellow-400' : 'border-gray-600'}`} data-id="element-131">
                {selected === 'premium' && <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" data-id="element-132" />}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0" data-id="element-133">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-134">
                  <span className="text-lg" data-id="element-135">🏆</span>
                  <h3 className="text-base md:text-lg font-black text-white uppercase tracking-wide" data-id="element-136">
                    PACK COMPLETO
                  </h3>
                </div>
                <div className="flex flex-wrap items-center gap-1.5 mb-1.5" data-id="element-137">
                  <span className="inline-flex items-center gap-1 bg-gradient-to-r from-yellow-600 to-yellow-500 text-black text-[10px] md:text-xs font-black px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-138">
                    ⭐ Más elegido
                  </span>
                  <span className="inline-flex items-center text-yellow-400 text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full border border-yellow-400/50 uppercase tracking-wider" data-id="element-139">
                    Ahorrás $10.000
                  </span>
                </div>
                <p className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-140">
                  6 libros + 600 citas + bonos
                </p>
                <div className="flex flex-col gap-0.5 mt-1.5" data-id="element-141">
                  <p className="text-xs text-yellow-300 font-bold" data-id="element-142">
                    + 💑 100 Citas en Pareja
                  </p>
                  <p className="text-xs text-yellow-300 font-bold" data-id="element-143">
                    + 👨‍👩‍👧 100 Citas en Familia
                  </p>
                </div>
              </div>

              {/* Price */}
              <div className="text-right flex-shrink-0" data-id="element-144">
                <p className="text-xs md:text-sm text-gray-500 line-through font-medium" data-id="element-145">
                  $59.990
                </p>
                <p className="text-2xl md:text-3xl font-black text-yellow-400" data-id="element-146">
                  $29.990
                </p>
              </div>
            </button>
          </div>

          {/* Persuasive nudge for Pack Completo */}
          <div className="bg-gradient-to-r from-yellow-400/10 to-yellow-400/5 border border-yellow-400/30 rounded-lg p-3 mb-6 text-center" data-id="element-147">
            <p className="text-yellow-400 font-bold text-xs md:text-sm mb-1" data-id="element-148">
              💡 ¿Por qué el 80% de los padres eligen el Pack Completo?
            </p>
            <p className="text-gray-300 text-xs md:text-sm leading-relaxed" data-id="element-149">
              Porque saben que la familia se fortalece cuando{' '}
              <span className="text-white font-bold" data-id="element-150">
                todos los vínculos están cuidados
              </span>
              . Con el Pack Completo sumás{' '}
              <span className="text-yellow-400 font-bold" data-id="element-151">
                200 citas extra para tu pareja y toda la familia
              </span>{' '}
              por solo $10.000 más. La conexión con tus hijos empieza por la
              conexión con tu pareja.{' '}
              <span className="text-yellow-400 font-bold" data-id="element-152">
                No dejes pasar esta oportunidad.
              </span>
            </p>
          </div>

          {/* Checkout CTA — links to actual checkout based on selection */}
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full max-w-md mx-auto cta-pulse" data-id="element-153">
            <div className="w-full flex flex-col items-center justify-center px-4 py-3 md:px-5 md:py-4 bg-red-600 rounded-lg shadow-md text-white font-bold text-base md:text-lg hover:bg-red-700 transition-colors" data-id="element-154">
              <div className="flex items-center gap-2 text-center" data-id="element-155">
                👉 COMPRAR AHORA
              </div>
              <span className="text-xs md:text-sm font-medium text-red-100 mt-1" data-id="element-156">
                Descarga inmediata • Garantía de 7 días
              </span>
            </div>
          </a>

          <div className="flex items-center justify-center gap-3 mt-5 text-gray-500 text-xs md:text-sm" data-id="element-157">
            <span className="flex items-center gap-1" data-id="element-158">🔒 Pago seguro</span>
            <span data-id="element-159">•</span>
            <span className="flex items-center gap-1" data-id="element-160">
              📥 Descarga inmediata
            </span>
            <span data-id="element-161">•</span>
            <span className="flex items-center gap-1" data-id="element-162">✅ Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}